import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { taskKeys, RequestTypes } from '@core/react-query/features/tasks/task'
import { ITask } from '@core/entities/task/Task'
import { tasksKeys } from '@core/react-query/features/tasks/tasks'

export const useDeleteTaskDraft = () => {
  const { deleteInfiniteQueryItem } = useMutateQueryData()
  const queryClient = useQueryClient()

  return useMutation<ITask, RequestErrorType, RequestTypes['deleteTaskDraft']>({
    ...taskKeys.deleteTaskDraft,
    onSuccess: (draft, variables) => {
      deleteInfiniteQueryItem(
        tasksKeys.draftTasks({
          organisationId: variables.organisationId,
          projectIds: [variables.projectId],
        }).queryKey,
        variables.draftId,
      )

      queryClient.invalidateQueries(tasksKeys.draftTasks._def)
    },
  })
}
